import React from 'react';
import {
  Box,
  Typography,
  Button,
} from '@mui/material';
import { Lock } from 'lucide-react';

export default function UssdUnactivatedState() {

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 440,
        mx: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      {/* 1. Subtle Lock Icon Floating at Top */}
      <Box sx={{ color: '#6B7280', display: 'flex', justifyContent: 'center', mb: 0.5 }}>
        <Lock size={38} strokeWidth={1.4} />
      </Box>

      {/* 2. Bold Clean Heading */}
      <Typography
        variant="h1"
        sx={{
          fontWeight: 800,
          fontSize: { xs: '2.2rem', sm: '2.7rem' },
          color: '#111827',
          letterSpacing: '-0.035em',
          lineHeight: 1.15,
          mt: 2.5,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        USSD Offline
        <br />
        Channel
      </Typography>

      {/* 3. Concise Description */}
      <Typography
        sx={{
          fontSize: { xs: '1rem', sm: '1.05rem' },
          color: '#6B7280',
          fontWeight: 400,
          mt: 2,
          lineHeight: 1.48,
          maxWidth: 440,
        }}
      >
        Let customers dial a short code, like{' '}
        <Box component="strong" sx={{ color: '#111827', fontWeight: 600 }}>
          *384*...#
        </Box>
        , to buy data and airtime or check their balance without internet.
      </Typography>

      {/* 4. Coming Soon Pill Button */}
      <Box sx={{ width: '100%', maxWidth: 440, mt: 4 }}>
        <Button
          fullWidth
          disabled
          variant="contained"
          sx={{
            py: 1.6,
            borderRadius: '9999px',
            fontSize: '1rem',
            fontWeight: 600,
            textTransform: 'none',
            boxShadow: 'none',
            bgcolor: '#F3F4F6',
            color: '#9CA3AF',
            cursor: 'not-allowed',
            '&.Mui-disabled': {
              bgcolor: '#F3F4F6',
              color: '#9CA3AF',
            },
          }}
        >
          Coming Soon
        </Button>
      </Box>

      {/* 5. Feature List with Thin Clean Dividers */}
      <Box sx={{ width: '100%', maxWidth: 440, mt: { xs: 5, sm: 6 }, textAlign: 'left' }}>
        <Box sx={{ borderTop: '1px solid #E5E7EB' }}>
          <Box sx={{ py: 2 }}>
            <Typography sx={{ fontWeight: 600, color: '#111827', fontSize: '0.95rem' }}>
              Works on every phone
            </Typography>
            <Typography sx={{ color: '#6B7280', fontSize: '0.875rem', mt: 0.35 }}>
              MTN, Airtel, Glo and 9mobile.
            </Typography>
          </Box>
        </Box>

        <Box sx={{ borderTop: '1px solid #E5E7EB' }}>
          <Box sx={{ py: 2 }}>
            <Typography sx={{ fontWeight: 600, color: '#111827', fontSize: '0.95rem' }}>
              Automatic failover
            </Typography>
            <Typography sx={{ color: '#6B7280', fontSize: '0.875rem', mt: 0.35 }}>
              Routes to your configured providers.
            </Typography>
          </Box>
        </Box>

        <Box sx={{ borderTop: '1px solid #E5E7EB' }} />
      </Box>
    </Box>
  );
}
